<template>
    <div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    export default {
        name: 'callback',
        methods: {
            ...mapActions('oidcStore', [
                'oidcSignInCallback'
            ])
        },
        created() {
            let that = this;
            this.oidcSignInCallback()
                .then((redirectPath) => {
                    that.$router.push(redirectPath);
                })
                .catch((err) => {
                    console.error("callback", err);
                    //var keys = Object.keys(localStorage),
                    //    i = keys.length;
                    //while (i--) {
                    //    if (keys[i].startsWith("oidc"))
                    //        localStorage.removeItem(keys[i]);
                    //}
                    this.$router.push('/') // Handle errors any way you want
                })
        }
    }
</script>
